<template>
    <div class="account-page-padding">
        <div class="company-info">
            <div class="header">
                <h1>Company Info</h1>
            </div>
            <div v-if="is_dealer && accountLevel === 'Administrator'" class="company-info-fields two-column-form">
                <div class="input-row">
                    <div v-if="!isEditing && message != null" :class="`notification notification-success`">
                        <p class="paragraph-details">{{ message }}</p>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="company.rothco_dealer_no" 
                                type="text" 
                                id="rothco_dealer_no" 
                                placeholder=" " 
                                :readonly="true"
                                autocomplete="false"
                                maxlength="48"
                            />
                            <label for="rothco_dealer_no">
                                <p class="paragraph-default">Rothco Dealer No</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state"></p>
                    </div>
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="company.primary_email"
                                type="text" 
                                id="primary_email" 
                                placeholder=" " 
                                :readonly="true"
                                autocomplete="false"
                                name="primary_email"
                                maxlength="48"
                            />
                            <label for="primary_email">
                                <p class="paragraph-default">Primary Email</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state"></p>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.company_name" 
                                type="text" 
                                id="company_name" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your name"
                                :readonly="!isEditing"
                                autocomplete="false"
                                maxlength="48"
                            />
                            <label for="company_name">
                                <p class="paragraph-default">Company Name *</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.company_name }}</p>
                    </div>
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.address_1"
                                type="text" 
                                id="address_1" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your street"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="address_1"
                                maxlength="48"
                            />
                            <label for="address_1">
                                <p class="paragraph-default">Street 1 *</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.address_1 }}</p>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.address_2"
                                type="text" 
                                id="address_2" 
                                placeholder=" "
                                aria-label="Enter your street 2"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="address_2"
                                maxlength="48"
                            />
                            <label for="address_2">
                                <p class="paragraph-default">Street 2 </p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.address_2 }}</p>
                    </div>
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.address_3"
                                type="text" 
                                id="address_3" 
                                placeholder=" " 
                                aria-label="Enter your street 3"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="address_3"
                                maxlength="48"
                            />
                            <label for="address_3">
                                <p class="paragraph-default">Street 3 (Suite, Unit, PO Box)</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.address_3 }}</p>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.city"
                                type="text" 
                                id="city" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your city"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="city"
                                maxlength="30"
                            />
                            <label for="city">
                                <p class="paragraph-default">City {{ requireStateCity ? '*' : '' }}</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.city }}</p>
                    </div>
                    <div v-if="formattedRegions" class="selectore-state select-wrapper state-input">
                        <custom-select 
                            name="state"
                            id="state"
                            aria-label="Select your state"
                            :label="`State ${requireStateCity ? '*' : ''}`"
                            v-model="selectedRegion"
                            :readonly="!isEditing"
                            :options="formattedRegions"
                        />
                        <div class="field-state input-folder"><p class="input-support-text invalid-state">{{ companyform.errors.state }}</p></div>
                    </div>
                    <div v-else class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.state"
                                type="text" 
                                id="state" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your state"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="state"
                                maxlength="30"
                            />
                            <label for="state">
                                <p class="paragraph-default">State {{ requireStateCity ? '*' : '' }}</p>
                            </label>
                            <div class="field-state input-folder"><p class="input-support-text invalid-state">{{ companyform.errors.state }}</p></div>
                        </div>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.zip"
                                type="text" 
                                id="zip" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your postal or ZIP code"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="zip"
                                maxlength="12"
                            />
                            <label for="zip">
                                <p class="paragraph-default">Postal / ZIP Code {{ requireStateCity ? '*' : '' }}</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.zip }}</p>
                    </div>
                    <div class="selectore-state select-wrapper state-input">
                        <custom-select 
                            v-model="selectedCountry"
                            label="Country *"
                            name="country"
                            id="country"
                            :readonly="!isEditing"
                            aria-label="Enter Country"
                            :options="formattedCountries"
                        />
                        <div class="field-state input-folder"><p class="input-support-text invalid-state">{{ companyform.errors.country }}</p></div>
                    </div>
                </div>
                <div class="input-row">
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyWebsite"
                                type="text" 
                                id="website" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your website"
                                :readonly="!isEditing"
                                autocomplete="false"
                                maxlength="48"
                            />
                            <label for="website">
                                <p class="paragraph-default">Website *</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.website }}</p>
                    </div>
                    <div class="field-state input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText
                                v-model="companyform.invoice_email"
                                type="text" 
                                id="invoice_email" 
                                placeholder=" " 
                                required 
                                aria-label="Enter your Invoice Email"
                                :readonly="!isEditing"
                                autocomplete="false"
                                name="invoice_email"
                                maxlength="48"
                            />
                            <label for="invoice_email">
                                <p class="paragraph-default">Invoice Email *</p>
                            </label>
                        </div>
                        <p class="input-support-text invalid-state">{{ companyform.errors.invoice_email }}</p>
                    </div>
                </div>
                <div class="actions">
                        <RothcoCta 
                            id="edit_button" 
                            @click.prevent="toggleEdit();" 
                            :inertia="false" 
                            cta-type="button" 
                            :class="[{ primary: !isEditing }]" 
                            v-bind:button_icon="isEditing ? null : undefined"
                        >
                            {{ isEditing ? 'Cancel Edit' : 'Edit' }}
                        </RothcoCta>
                        <RothcoCta id="save_button" v-if="isEditing" :disabled="companyform.processing" @click.prevent="saveCompanyInfo()" cta-type="button" class="primary" >Save</RothcoCta>
                    </div>
            </div>
            <div v-else class="banner banner--desktop-middle-center" style="min-height: 250px">
                <div class="banner__content">
                    <div class="banner__layout center-align">
                        <p class="paragraph-default text-rothcoBlack">Looks like you don't have permissions to view this page! Please contact your Administrator to request access.</p>
                    </div>
                </div>
            </div>
        
</div>
    </div>
</template>
<script setup lang="ts">
    import Account from "@/Shared/Account.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useForm } from "@/helpers/composables/useForm";
    import { string, number, date, boolean, object} from 'yup';
    import { computed, toRefs, ref, watch, onMounted, inject } from "vue";
    import { Link, router } from "@inertiajs/vue3";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { useWindowScroll } from "@vueuse/core";
    let route = inject("route");
    interface Company {
        rothco_dealer_no: string;
        company_name: string;
        address_1: string;
        address_2: string;
        address_3: string;
        city: string;
        state: string;
        country: string;
        primary_email: string;
        website: string;
        invoice_email: string;
    }

    interface Region {
        code: string;
        name: string;
    }

    interface Country {
        alpha3code: string;
        alpha2code: string;
        name: string;
    }

    let props = defineProps({
        company: {
            type: Object as PropType<Company>,
            default: () => ({
                rothco_dealer_no: "",
                primary_email: "",
                company_name: "",
                address_1: "",
                address_2: "",
                address_3: "",
                city: "",
                state: "",
                country: "",
                website: "",
                invoice_email: ""
            })
        },
        regions: {
            type: Array as PropType<Region[]>,
            default: () => []
        },
        countries: {
            type: Array as PropType<Country[]>,
            default: () => []
        },
    });

    let store = useSettingsStore();
    let { is_dealer, accountLevel } = storeToRefs(store);

    let { company, regions, countries } = toRefs(props);

    const { y } = useWindowScroll({ behavior: 'smooth' })
    const scrollToTop = ()=>{
        y.value = 0;
    }

    const isEditing = ref(false);
    let message = ref(null);

    const toggleEdit = ()=>{
        isEditing.value = !isEditing.value;
        message.value = null;
        if(isEditing.value){
            companyform.validate({all: true});
        } else {
            companyform.reset();
        }
    }

    function setCompanyWebSite(website: string){
        if(website.includes('http://') || website.includes('https://')){
            return website;
        }
        return `https://${website}`;
    }

    const companyform = useForm({
        useInertia: false,
        schema: object({
            company_name: string().required('Company Name is required').default(company.value.company_name),
            address_1: string().required('Street1 is required').default(company.value.address_1),
            address_2: string().notRequired().default(company.value.address_2),
            address_3: string().notRequired().default(company.value.address_3),
            city: string().optional().test(
                'is-not-empty',
                'City is required',
                (value) => {
                    if(companyform.country == 'USA' || companyform.country == 'CAN'){
                        return  value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).default(company.value.city),
            state: string().optional().test(
                'is-not-empty',
                'State is required',
                (value) => {
                    if(companyform.country == 'USA' || companyform.country == 'CAN'){
                        return  value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).default(company.value.state),
            country: string().required('Country is required').default(company.value.country),
            zip: string().optional().test(
                'is-not-empty',
                'Please Enter a valid Zip Code',
                (value) => {
                    if(companyform.country == 'USA' || companyform.country == 'CA'){
                        return /^(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/.test(
                            value
                        );
                    }
                    return true;
                }
            ).default(company.value.zip),
            website: string().required('Website is required').default(setCompanyWebSite(company.value.website)),
            invoice_email: string().email('Invoice Email is not valid').required('Invoice Email is required').default(company.value.invoice_email),
        })
    });

    const requireStateCity = computed(()=>{
        return !!companyform.country && ['USA','CAN'].includes(companyform.country);
    })

    let formattedCountries = computed(()=>{
        return props.countries.map((country)=>{
            return {
                value: country.name,
                key: country.alpha3code
            }
        });
    });
    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(currentCountry=>currentCountry.key == companyform.country) ?? {key: '', value: ''};
        },
        set(value){
            companyform.country = value.key;
        }
    });
    const CANADA_STATE_CODES = new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']);
    let formattedRegions = computed(()=>{
        const regions = props.regions ?? [];
        const countryRegionMap = {
            'CAN': regions
                .filter(region => CANADA_STATE_CODES.has(region.code) && region.code !== 'PR')
                .map(region => ({ key: region.code, value: region.name })),
            'PRI': [{ key: 'PR', value: 'Puerto Rico' }],
            'USA': regions
                .filter(region => !CANADA_STATE_CODES.has(region.code))
                .map(region => ({ key: region.code, value: region.name }))
        };
        return countryRegionMap[companyform.country] ?? null;
    });
    let selectedRegion = computed({
        get(){
            return formattedRegions.value.find(currentRegion => currentRegion.key == companyform.state) ?? {key: '', value: ''};
        },
        set(newVal){
            companyform.state = newVal.key;
        }
    });
    watch(formattedRegions, (newVal) => {
        if(newVal){
            let state = companyform.state?.toLowerCase();
            for(let availableState of newVal){
                if(availableState.value?.toLowerCase() == state || availableState.key?.toLowerCase() == state){
                    companyform.state = availableState.key;
                    break;
                }
            }
        }
    });


    watch(() => companyform.country, (newCountryValue, oldCountryValue) => {
        if (!['USA', 'CAN', 'PRI'].includes(newCountryValue) && ['USA', 'CAN', 'PRI'].includes(oldCountryValue)) {
            companyform.state = '';
            return;
        }
        if (['USA', 'CAN', 'PRI'].includes(newCountryValue)) {
            let state = companyform.state?.toLowerCase();
            let availableStates = formattedRegions.value || [];

            let matchedState = availableStates.find(
                s => s.value?.toLowerCase() === state || s.key?.toLowerCase() === state
            );
            companyform.state = matchedState ? matchedState.key : '';
        }
    });

    const companyWebsite = computed({
        get(){
            return companyform.website;
        },
        set(newVal){
            companyform.website = setCompanyWebSite(newVal);
        }
    });


    const saveCompanyInfo = () => {
        if(companyform.processing) return;

        companyform.post(
            route("account.company.update"),
                {
                    ...companyform,
                },
                {
                    afterFetch: (response) => {
                        router.reload({ only: ['company'] });
                        isEditing.value = false;
                        message.value = response?.data?.message ?? null;
                        if(message.value && !response?.data?.errors){
                            scrollToTop();
                        }
                    }
                }
            );
    };

    watch(() => company.value, (newCompany) => {
        companyform.defaults(newCompany);
    }, { deep: true });

</script>
